'use strict';

module.exports = window.crypto || window.msCrypto;